import { render, staticRenderFns } from "./NewsViewItem.vue?vue&type=template&id=ff6706aa&scoped=true"
import script from "./NewsViewItem.vue?vue&type=script&lang=js"
export * from "./NewsViewItem.vue?vue&type=script&lang=js"
import style0 from "./NewsViewItem.vue?vue&type=style&index=0&id=ff6706aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6706aa",
  null
  
)

export default component.exports